<template>
  <div class="route-details__container">
    <div class="flex flex-row justify-content-start mb-4 gap-3">
      <div class="value-container ">
        Distancia total:
        <span class="font-bold pl-2">
          <h4>{{ getDistanceString(props.routeInfo.totalDistance) }}</h4>
        </span>
      </div>
      <div class="value-container">
        Tiempo total:
        <span class="font-bold pl-2">
          <h4>{{ getTimeString(props.routeInfo.totalTime) }}</h4>
        </span>
      </div>
    </div>
    <!-- :value="props.routeInfo.route" -->
    <Timeline
      :value="timeLineInfo"
      align="right"
      :unstyled="false"
    >
      <template #content="slotProps">
        <div
          v-if="slotProps.item.roadType != 'Fin_ruta'"
          class="route-info-item__road"
        >
          <span>{{ slotProps.item.road }}</span><br />
          <span>{{ getDistanceString(slotProps.item.routeDistance) }}</span><br />
          <span>{{ getTimeString(slotProps.item.routeTime) }}</span><br />
        </div>
      </template>
      <template #connector="slotProps">
        <div :class="connectorClasses(slotProps.item)"></div>
      </template>
      <template #marker="slotProps">
        <div :class="markerClasses(slotProps.item)"></div>
      </template>
      <template #opposite="slotProps">
        <div
          class="route-info-item__poi-list"
        >
          <RoutePoiList
            :poi-information="slotProps.item.information"
            :poi-list="slotProps.item.poiList"
            @go-coordinates="goCoordinates"
          />
        </div>
      </template>
    </Timeline>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import Timeline from 'primevue/timeline';
import RoutePoiList from '@/components/route-poi-list/RoutePoiList';
import {getTimeString, getDistanceString} from '@/util';

// #region Props, Emits
const props = defineProps({
  routePointStart: {
    type: Object,
    required: true,
  },
  routePointEnd: {
    type: Object,
    required: true,
  },
  routeInfo: {
    type: Object,
    default: () => {
      routeInfo: [];
    },
  },
});
const emit = defineEmits(['goCoordinates']);
// #endregion

// #region Params, Ref, Reactives, Computed
const timeLineInfo = computed(() => {
  // Copy of route info
  const info = props?.routeInfo?.route ? [...props.routeInfo.route] : [];
  const lastStop = props.routePointStart;
  if (!!info && !!info.length && !!lastStop) {
    // info.push(lastStop);
  }
  return info;
});
// #endregion

// #region Functions
async function goCoordinates(infoCoordinates) {
  emit('goCoordinates', infoCoordinates);
}
function markerClasses(item) {
  const classes = [
    'p-timeline-event-marker',
    'route-details__marker',
  ];
  switch (item.roadType) {
    case 'red_urbana':
      break;
    default:
      break;
  }
  return classes.join(' ');
}
function connectorClasses(item) {
  const classes = [
    'p-timeline-event-connector',
    'route-details__connector',
  ];
  let rType = item.roadType;
  rType = rType + (!!item.roadTypeCategory ? '-' + item.roadTypeCategory : '');
  classes.push('route-details__connector--' + rType);
  if (item) {
    return classes.join(' ');
  }
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/custom-colors.scss";

.route-details {
  &__container :deep(.p-timeline-event) {
    width: 100%;
  }
  &__container :deep(.p-timeline-event-content) {
    align-self: center;
    max-width: 12rem;
  }
  &__container .route-info-item {
    &__road {
      display: block;
    }
    &__poi-list {
      display: block;
    }
  }

  &__marker {
    width: 1.5rem;
    height: 1.5rem;
    background-color: yellow;
    border: 3px solid black;
  }
  &__connector {
    width: 8px !important;
    border-top: none !important;
    border-bottom: none !important;
    &--autonomica-1 {
      background-color: orange;
      border: 2px solid black;
    }
    &--autonomica-2 {
      background-color: green;
      border: 2px solid grey;
    }
    &--autonomica-3 {
      background-color: yellow;
      border: 2px solid grey;
    }
    &--otras {
      background-color: grey;
    }
    &--red_principal {
      background-color: red;
      border: 2px solid black;
    }
    &--red_urbana {
      background-color: black;
    }

    /* Autovía - Autopista libre con línea longitudinal central*/
    &--autopista,
    &--autopista-peaje {
      position: relative;
      background-color: white;
      border: 2px solid red;
      &::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        width: 2px;
        height: 100%;
        background-color: red;
      }
    }
      /* Autopista (de peaje) */
    &--autopista-peaje {
        background-color: yellow;
    }

    /* Multicarril*/
    &--autovia {
      background-color: white;
      border: 2px solid red;
    }
  }
}

.value-container {
    display: flex;
    padding: 6px 8px;
    cursor: pointer;
    border: .5px solid #ccc;
    background-color: $container-background-gray;
    border-radius: 8px;
    transition: background-color .2s ease;
  }
</style>
